export const PBI_BEARER_TOKEN = "PBI_BEARER_TOKEN";
export const PBI_EMBED_TOKEN = "PBI_EMBED_TOKEN";
export const PBI_UPDATE_DATASET = "PBI_UPDATE_DATASET";
export const PBI_RESET = "PBI_RESET";
// export const PBI_UPDATE_DATASET_SUCCESS = 'PBI_UPDATE_DATASET_SUCCESS';
// export const PBI_UPDATE_DATASET_FAILURE = 'PBI_UPDATE_DATASET_FAILURE';
